import { Card } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import moment from "moment";
import {
  calculatePercentage,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import React, { useContext, useState, useEffect, useMemo } from "react";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_TESTSYLLABUS_STATUS,
  GET_BATCH_TEST_DETAILS,
  DOWNLOAD_MEDPRO_URL,
} from "utilFunctions/Constants/urlConstants";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { returnRiskSegment } from "Pages/SyllabusCompliances/SyllabusComplianceBatchTable";
import { useNavigate, useParams } from "react-router-dom";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Table, Popover, Space, Tag } from "antd";
import { CustomMyBatchCard } from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailTab";
import { Button } from "antd";
import { DownloadOutlined, UndoOutlined } from "@ant-design/icons";
import { putPostRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import putPostRequestInterface from "utilFunctions/Axios/putPostRequestInterface";
import { myBatchEmitter } from "Pages/MyBatches/EmitterBus";
const COLOR_TAG: any = {
  Initiated: "orange",
  Completed: "green",
  Retry: "blue",
  Failed: "red",
  Progressing: "yellow",
  Queued: "purple",
};
export const returnPlannedLecture = (val1: number, val2: number) => {
  return val1 + "/" + val2;
};
export const popBodyShowComponent: any = (popoverContent: any) => {
  return (
    <>
      <div className="d-flex gap-2">
        {popoverContent?.map((ele: any) =>
          returnRiskSegment(
            roundToAnyDecimalPlaces(
              Number(
                displayNumberWithDecimals(
                  calculatePercentage(ele.markedNodeCount, ele.totalNodeCount)
                )
              ),
              2
            ),
            ele?.subject &&
              capitalizeFirstCharaterOfString(ele?.subject) +
                " : " +
                roundToAnyDecimalPlaces(
                  Number(
                    displayNumberWithDecimals(
                      calculatePercentage(
                        ele.markedNodeCount,
                        ele.totalNodeCount
                      )
                    )
                  ),
                  2
                ) +
                " %",
            false
          )
        )}
      </div>
    </>
  );
};
const MyBatchTestsTab = ({
  testSyllabusStatus,
  setTestSyllabusStatus,
  testDetailsFilter,
  batchDetailById,
  testTypes,
  filterListing,
  setFilterState,
  batchDetailsData,
}: any) => {
  const [showPastTest, setShowPastTest] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [testDetailsData, settestDetailsData] = useState<any>(null);
  const [testDetailsMasterData, setTestDetailsMasterData] = useState<any>(null);
  const ToastDispatch = useContext(ToastContextDispatch);
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Test Type",
      nickName: "testTypes",
      data: testTypes,
      singleSelect: true,
      filterSelectedData: [],
    },
  ]);
  const [testDataMap, setTestDataMap] = useState(new Map());
  const [loadingMap, setLoadingMap] = useState<Map<number, boolean>>(new Map());
  useEffect(() => {
    const newMap = new Map(testDataMap);
    (testDetailsData || []).forEach((ele: any) => {
      newMap.set(ele.id, {});
    });
    setTestDataMap(newMap);
  }, [testDetailsData]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Test Type",
        nickName: "testTypes",
        data: testTypes,
        singleSelect: true,
        filterSelectedData: [],
      },
    ]);
  }, [batchDetailById]);
  const { makeRequest: PostTestSyllabusStatus } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        console.log("checking test syllabus data", data["data"]);
        setTestSyllabusStatus(data["data"]);
      } else {
        setTestSyllabusStatus([]);
      }
    },
    (error) => {
      console.log("no test syllabus data found");
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    },
    "Post"
  );

  const PostDownloadMedPro = (url: string, data: any, testId: number) => {
    putPostRequest({
      url: url,
      success: (data: any) => {
        const response = data["data"]?.data || {};
        handlePostData(response, testId);
      },
      failure: (error: any) => {
        if (error && error["message"]) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: error.message,
          });
        }
      },
      body: data,
      method: "post",
    } as putPostRequestInterface);
  };
  const handlePostData = (response: any, testId: number) => {
    const { jobStatus, url } = response;
    if (jobStatus === "Completed") {
      if (url) {
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "medpro.zip";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No scoretool data found",
        });
      }
    }
    const newMap = new Map(testDataMap);
    newMap.set(testId, response);
    setTestDataMap(newMap);
  };
  const returnBatchData = (id: number) => {
    return testSyllabusStatus.filter(
      (ele: any) => ele.testScheduleId === id
    )?.[0]?.testSyllabusStatusDataList;
  };

  const { makeRequest: GetTestDetailsData, loading: tableloading } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        setTestDetailsMasterData(data["data"]);
        settestDetailsData(data["data"]);
      } else {
        setTestDetailsMasterData([]);
        settestDetailsData([]);
      }
    },
    (error) => {
      console.log("batch data from API error");
      setTestDetailsMasterData([]);
      settestDetailsData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const handler = (value: string, myBatchFilter: any) => {
    const showPastTest =
      myBatchFilter && myBatchFilter.uptestType == "Past Tests" ? true : false;
    setShowPastTest(showPastTest);
    const batchTestUrl = `${BASE_URL}${GET_BATCH_TEST_DETAILS}?batchId=${id}&showPastTest=${showPastTest}`;
    GetTestDetailsData(batchTestUrl);
  };
  useEffect(() => {
    myBatchEmitter.on("toggleTab", handler);
    return () => {
      myBatchEmitter.off("toggleTab", handler);
    };
  }, []);
  useEffect(() => {
    const batchTestUrl = `${BASE_URL}${GET_BATCH_TEST_DETAILS}?batchId=${id}&showPastTest=${showPastTest}`;
    GetTestDetailsData(batchTestUrl);
  }, [showPastTest]);

  useEffect(() => {
    if (testDetailsMasterData) {
      if (
        testDetailsFilter &&
        testDetailsFilter != null &&
        testDetailsFilter != ""
      ) {
        const filteredList = testDetailsMasterData.filter(
          (obj: any) => obj["type"] == testDetailsFilter
        );
        settestDetailsData(filteredList);
      } else {
        const batchTestUrl = `${BASE_URL}syllabusCompliance/batchTests?batchId=${id}&showPastTest=${showPastTest}`;
        console.log("URL FOR BATCH DETAILS abcd", batchTestUrl);
        GetTestDetailsData(batchTestUrl);
      }
    }
  }, [testDetailsFilter]);

  const { screen }: any = useWindowSize();
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };
  const routeToMyBatch = (item: any) => {
    navigate("/admin/mybatch/test/" + item.id, {
      replace: false,
      state: {
        test: item,
        batchId: id,
        testSyllabusStatus,
        batchName: batchDetailsData.batchName,
      },
    });
  };
  const columns: any = useMemo(() => {
    return [
      {
        title: "Test Name",
        dataIndex: "type",
        width: 90,
        fixed: "left",
        render: (_: any, item: any) => {
          return (
            <span className="filterSpan" onClick={() => routeToMyBatch(item)}>
              {item?.type}
            </span>
          );
        },
      },
      {
        title: "Start Date-End Date",
        dataIndex: "startDate",
        width: 120,
        render: (_: any, item: any) => {
          return (
            <div className="d-flex">
              {renderingTime(item.startDate)}
              {"-"}
              {renderingTime(item.endDate)}{" "}
            </div>
          );
        },
      },
      {
        title: "Format | Mode",
        dataIndex: "format",
        width: 120,
        render: (_: any, item: any) => {
          return (
            <>
              {" "}
              {item?.format} | {item?.mode}
            </>
          );
        },
      },
      {
        title: "Result Date",
        dataIndex: "resultDate",
        width: 90,
        fixed: "left",
        render: (_: any, item: any) => {
          return <span>{renderingTime(item?.resultDate)}</span>;
        },
      },
      {
        title: "Syllabus Status",
        dataIndex: "testSyllabusStatus",
        width: 160,
        render: (_: any, item: any) => {
          return (
            <div>
              {returnBatchData(item.id) ? (
                <Popover
                  placement="leftTop"
                  content={() => (
                    <>
                      <div className="plannedLectureHeading">
                        Total topics covered for the test
                      </div>
                      {returnBatchData(item.id).map(
                        (ele: any, index: number) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between mb-2"
                          >
                            {returnRiskSegment(
                              roundToAnyDecimalPlaces(
                                Number(
                                  displayNumberWithDecimals(
                                    calculatePercentage(
                                      ele.markedNodeCount,
                                      ele.totalNodeCount
                                    )
                                  )
                                ),
                                0
                              ),
                              ele?.subject,
                              false
                            )}
                            <div className="statusHeading">
                              {returnPlannedLecture(
                                ele.markedNodeCount,
                                ele.totalNodeCount
                              )}
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                >
                  {returnBatchData(item.id)
                    ? popBodyShowComponent(returnBatchData(item.id))
                    : "-"}
                </Popover>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      ...(showPastTest
        ? [
            {
              title: "Download",
              dataIndex: "download",
              width: 10,
              fixed: "right",
              render: (_: any, item: any) => {
                const medProData = testDataMap.get(item.id);
                return (
                  <Space>
                    <Button
                      type="text"
                      className="filterSpan"
                      loading={loadingMap.get(item.id) || false}
                      disabled={loadingMap.get(item.id) || false}
                      icon={
                        !medProData?.jobStatus ? (
                          <DownloadOutlined style={{ color: "#00B0F5" }} />
                        ) : (
                          <>
                            {medProData?.jobStatus === "Completed" ? (
                              <DownloadOutlined style={{ color: "#00B0F5" }} />
                            ) : (
                              <UndoOutlined style={{ color: "#00B0F5" }} />
                            )}
                          </>
                        )
                      }
                      onClick={() => handleDownload(item.id)}
                    ></Button>

                    {medProData?.jobStatus && (
                      <Tag color={COLOR_TAG[medProData.jobStatus]}>
                        {medProData?.jobStatus}
                      </Tag>
                    )}
                  </Space>
                );
              },
            },
          ]
        : []),
    ];
  }, [showPastTest, loadingMap, testDataMap]);
  const handleDownload = (testId: number) => {
    try {
      const newLoadingMap = new Map(loadingMap);
      newLoadingMap.set(testId, true);
      setLoadingMap(newLoadingMap);
      const obj = {
        testId: testId,
        batchId: Number(id),
      };
      PostDownloadMedPro(`${BASE_URL}${DOWNLOAD_MEDPRO_URL}`, obj, testId);
    } catch (error) {
      console.log("error", error);
    } finally {
      setTimeout(() => {
        const updatedLoadingMap = new Map(loadingMap);
        updatedLoadingMap.set(testId, false);
        setLoadingMap(updatedLoadingMap);
      }, 2000);
    }
  };

  const clearHandler = () => {
    const clearedFilter = {
      stream: null,
      segment: null,
      status: null,
      clazz: null,
      subjectList: null,
    };

    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    settestDetailsData(testDetailsMasterData);
  };
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    const filteredList = testDetailsMasterData.filter(
      (ele: any) => ele["type"] === obj["testTypes"]["label"]
    );
    settestDetailsData(filteredList);
    setFilterState(obj);
  };
  useEffect(() => {
    if (testDetailsData && testDetailsData.length > 0) {
      const url = BASE_URL + GET_TESTSYLLABUS_STATUS;
      const obj = (testDetailsData || []).map((ele: any) => {
        const newObj = {
          batchId: id,
          testScheduleId: ele.id,
        };
        testDataMap.set(ele.id, "");
        return newObj;
      });
      const filteredList = obj.filter((ele: any) => ele.testScheduleId != null);
      if (filteredList.length > 0) {
        PostTestSyllabusStatus(url, filteredList);
      }
    }
  }, [testDetailsData]);
  return (
    <CustomMyBatchCard screen={screen}>
      <div
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "myBatchTable"
            : "myBatchTableMB"
        }
      >
        {["xs", "sm", "md"].includes(screen) &&
          !!filterheadingListing.length && (
            <FilterSliderComponent
              width={"100%"}
              isPaneOpen={globalSearchData?.isMyBatch}
              setisPaneOpen={() => {
                saveGlobalSearchData({
                  pathurl: null,
                  isStudentHealth: false,
                  isBranchHealth: false,
                  isPerformance: false,
                  isBatches: false,
                  isMyBatch: false,
                });
              }}
              hideHeader={true}
              filterheadingListing={filterheadingListing.filter((ele: any) =>
                filterListing.includes(ele.nickName)
              )}
              setfilterheadingListing={setfilterheadingListing}
              applyFilterHandler={applyFilterHandler}
              resetHandler={clearHandler}
            ></FilterSliderComponent>
          )}
        <Card className="mb-0 table-border-custom">
          <div className="tableFixHead">
            {!tableloading &&
            testDetailsData &&
            testDetailsData.length === 0 ? (
              <div className="mt-4 mb-8">
                <NoResultFoundSearch
                  primaryMessage="Scheduled test list not available."
                  secondaryMessage={
                    "No tests scheduled for this batch in Phoenix. Contact your EDP team for assistance."
                  }
                >
                  <NoDataFoundIcon />
                </NoResultFoundSearch>
              </div>
            ) : (
              <TableLayoutAntd isLoader={tableloading}>
                <Table
                  className="antdTablePagination"
                  scroll={{ x: "max-content" }}
                  bordered
                  size="small"
                  columns={columns}
                  dataSource={testDetailsData}
                  pagination={false}
                />
              </TableLayoutAntd>
            )}
          </div>
        </Card>
      </div>
    </CustomMyBatchCard>
  );
};

export default MyBatchTestsTab;
